const MAP_TYPE = {
  SECTION: 'section',
  ZONE: 'zone',
  HYBRID: 'zone',
};

export const MAP_TYPE_BY_INDEX = [MAP_TYPE.SECTION, MAP_TYPE.ZONE, MAP_TYPE.HYBRID];

export default MAP_TYPE;
